import { render, staticRenderFns } from "./bonusv1.vue?vue&type=template&id=325d6b8c&scoped=true"
import script from "./bonusv1.vue?vue&type=script&lang=js"
export * from "./bonusv1.vue?vue&type=script&lang=js"
import style0 from "./bonusv1.vue?vue&type=style&index=0&id=325d6b8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325d6b8c",
  null
  
)

export default component.exports